// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati/articoli-padre?societaId&q',
    requestBody: null,
    response: '[{id,codice,descrizioneBase,umVenditaSimbolo}]'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati/cerca-articoli?societaId&tipologia&categoriaMerceologicaId&q',
    requestBody: null,
    response: '[{id,codice,descrizioneBase,umVenditaSimbolo,formatoId,formatoNome,haFormato}]'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati/sfridi-formato?societaId&formatoId',
    requestBody: null,
    response: '[{id,quantitaDa,quantitaA,sfrido}]'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati/modelli?societaId',
    requestBody: null,
    response: '[{id,codice,nome,articoloPadreId,...,componenti:[...]}]'
  },
  {
    method: 'POST',
    endpoint: '/api/articoli-preconfigurati',
    requestBody: '{societaId,nome,articoloPadreId,modelloId}',
    response: '{id,codice,nome}'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati?societaId&modelloId&articoloPadreId&q',
    requestBody: null,
    response: '[{id,codice,nome,...}]'
  },
  {
    method: 'DELETE',
    endpoint: '/api/articoli-preconfigurati/:id',
    requestBody: null,
    response: '{success:true}'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati/:id',
    requestBody: null,
    response: '{id,codice,nome,componenti:[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/articoli-preconfigurati/:id',
    requestBody: null,
    response: '{id,codice,nome,componenti:[...]}'
  },
  {
    method: 'POST',
    endpoint: '/api/articoli-preconfigurati',
    requestBody: '{societaId,nome,articoloPadreId,componenti:[...]}',
    response: '{id,codice,nome}'
  },
  {
    method: 'PUT',
    endpoint: '/api/articoli-preconfigurati/:id',
    requestBody: '{nome,articoloPadreId,componenti:[...]}',
    response: 'articolo completo'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
